"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placeholder = exports.linkGroupDict = exports.groupParams = exports.destinationPickerName = exports.defaultExtendedGroupIds = exports.START_OPTIONS_COUNT = exports.DEFAULT_IMAGE = void 0;

var _cdn = require("@lt/components/constants/cdn");

var _userflow = require("@lt/components/utils/userflow");

var plural = {
  countries: ['страна', 'страны', 'стран'],
  metaregions: ['впечатление', 'впечатления', 'впечатлений']
};
var groupParams = {
  popularCountries: {
    label: 'Популярные страны',
    showMoreTitle: function showMoreTitle(count) {
      return "\u0415\u0449\u0451 ".concat(count, " ").concat((0, _userflow.pluralize)(count, plural.countries));
    }
  },
  popularDirections: {
    label: 'Популярные направления'
  },
  metaregions: {
    label: 'Отдых по впечатлениям',
    showMoreTitle: function showMoreTitle(count) {
      return "\u0415\u0449\u0451 ".concat(count, " ").concat((0, _userflow.pluralize)(count, plural.metaregions));
    }
  },
  allCountries: {
    label: ''
  },
  allMetaregions: {
    label: ''
  },
  regions: {
    label: 'Регион'
  },
  hotels: {
    label: 'Отель'
  },
  countries: {
    label: 'Страны'
  },
  any: {
    label: 'Любой'
  }
};
exports.groupParams = groupParams;

var placeholder = function placeholder(menuIsOpen, searchType) {
  if (!menuIsOpen) {
    return 'Куда хотите поехать?';
  }

  if (searchType === 'trip') {
    return 'Страна, город или регион';
  }

  return 'Страна, курорт или отель';
};

exports.placeholder = placeholder;
var destinationPickerName = 'lt-destination-picker';
exports.destinationPickerName = destinationPickerName;
var defaultExtendedGroupIds = ['popularCountries', 'metaregions', 'popularDirections'];
exports.defaultExtendedGroupIds = defaultExtendedGroupIds;
var linkGroupDict = {
  allCountries: 'popularCountries',
  allMetaregions: 'metaregions',
  allDirections: 'directions'
};
exports.linkGroupDict = linkGroupDict;
var START_OPTIONS_COUNT = 5;
exports.START_OPTIONS_COUNT = START_OPTIONS_COUNT;
var DEFAULT_IMAGE = "".concat(_cdn.CDN_LEVEL_TRAVEL, "/lt-modules-assets/main/header_bg.jpg");
exports.DEFAULT_IMAGE = DEFAULT_IMAGE;